import api from "../../../core/http";

export const createComicNote = (comicId, text, privacy) =>
  api
    .post(`/v1/comics/${comicId}/notes`, { text, privacy })
    .then((response) => response.data);

export const updateComicNote = (comicId, noteId, text, privacy) =>
  api
    .patch(`/v1/comics/${comicId}/notes/${noteId}`, { text, privacy })
    .then((response) => response.data);

export const deleteComicNote = (comicId, noteId) =>
  api.delete(`/v1/comics/${comicId}/notes/${noteId}`);
